import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calculateBarWidth',
  standalone: false,
})
export class CalculateBarWidthPipe implements PipeTransform {
  transform(available: number | undefined, value1: number | undefined): string {
    const quotient = available ? (value1 ?? 0) / available : 0;
    return `${quotient * 100}%`;
  }
}
